export default __webpack_public_path__ + "static/media/NMAH.AC.0433_ref11163.e80a441b.jpg";